import React, { useState } from "react";
import { toast } from "sonner";
import { MessageSquarePlus, Check } from "lucide-react";
import client, { apiError } from "../lib/api";
import { SectionTitle, Card } from "../components/common";

const inp = "w-full border border-pslborder rounded-sm p-2.5 text-sm focus:outline-none focus:border-gold";
const CATEGORIES = ["general", "bug", "fantasy", "advertising", "content", "clubs"];

export default function FeedbackPage() {
  const [form, setForm] = useState({ name: "", email: "", category: "general", message: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (form.message.trim().length < 3) { toast.error("Please enter a message"); return; }
    setBusy(true);
    try {
      await client.post("/feedback", { name: form.name || null, email: form.email || null, category: form.category, message: form.message });
      setSent(true);
      toast.success("Thank you — your feedback reached the PSL team");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl mx-auto" data-testid="feedback-page">
      <SectionTitle kicker="We're listening">Send feedback</SectionTitle>
      {sent ? (
        <Card className="p-8 text-center" data-testid="feedback-success">
          <div className="w-12 h-12 rounded-full bg-green text-cream flex items-center justify-center mx-auto mb-3"><Check /></div>
          <h3 className="font-head font-black text-xl text-green">Feedback received</h3>
          <p className="text-sm text-ink/60 mt-1">Thank you for helping us improve premierleaguezw.com.</p>
          <button onClick={() => { setSent(false); setForm({ name: "", email: "", category: "general", message: "" }); }} className="mt-4 px-4 py-2 bg-gold text-ink font-bold rounded-sm">Send another</button>
        </Card>
      ) : (
        <Card className="p-6">
          <div className="flex items-center gap-2 mb-4 text-green"><MessageSquarePlus size={18} /><span className="font-head font-bold">Tell the PSL team what you think</span></div>
          <div className="grid sm:grid-cols-2 gap-3 mb-3">
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name (optional)" className={inp} data-testid="feedback-name" />
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email (optional)" className={inp} data-testid="feedback-email" />
          </div>
          <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className={inp + " mb-3"} data-testid="feedback-category">
            {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Your feedback, ideas or issues…" rows={5} className={inp + " mb-4"} data-testid="feedback-message" />
          <button onClick={submit} disabled={busy} className="w-full py-3 bg-green text-cream font-bold rounded-sm hover:bg-ink transition-colors disabled:opacity-50" data-testid="feedback-submit">
            {busy ? "Sending…" : "Send feedback"}
          </button>
          <p className="text-[11px] text-ink/40 mt-2 text-center">We never ask for passwords or payment details. Your note goes to the PSL admin team.</p>
        </Card>
      )}
    </div>
  );
}
